import { Component, inject, Input } from '@angular/core';

import { SharedButtonComponent } from '@plugins/client/button/shared-button';
import { CancelIconComponent } from '@plugins/client/icons/cancel-icon';
import { TranslatePipe } from '@plugins/client/translate/pipes';

import { DialogComponent } from '../../dialog.component';
import { DialogTranslationModule } from '../../translation-loader';

@Component({
  selector: 'plugins-modal-header',
  imports: [
    DialogTranslationModule,
    TranslatePipe,
    SharedButtonComponent,
    CancelIconComponent,
  ],
  templateUrl: './modal-header.component.html',
  styleUrl: './modal-header.component.scss',
})
export class ModalHeaderComponent {
  @Input() closeLabel?: string;

  dialogRef = inject(DialogComponent);
}
